@if (instrument) {
  <div class="grid-container margin-top">
    <h2>{{ getInstrumentType() }} - {{ organization?.name }}</h2>
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell medium-4">
        <div class="bold">Id:</div>
        {{ instrument.id }}
      </div>
      <div class="cell medium-8">
        <div class="bold">Associated Well API:</div>
        {{ instrument.wellId }}
      </div>
      @if (instrument.cancelDate) {
        <div class="cell medium-4">
          <div class="bold red">Cancelled:</div>
          {{ instrument.cancelDate | date }}
        </div>
        <div class="cell small-4">
        </div>
        <div class="cell small-4">
        </div>
      }
      @if (instrument.replacedInstrument) {
        <div class="cell medium-4">
          <div class="bold">Replaced Instrument Id:</div>
          {{ instrument.replacedInstrument.id }}
        </div>
        <div class="cell medium-4">
          <div class="bold">Replaced Instrument Number:</div>
          {{ instrument.replacedInstrument.instrumentId }}
        </div>
        <div class="cell medium-4">
          <div class="bold">Date the replacement was approved:</div>
          {{ instrument.replacedInstrument.replacementApprovalDate | date }}
        </div>
      }
      @if (instrument.replacedBy) {
        <div class="cell medium-4">
          <div class="bold">Replaced By Instrument Id:</div>
          {{ instrument.replacedBy.id }}
        </div>
        <div class="cell medium-4">
          <div class="bold">Replaced By Instrument Number:</div>
          {{ instrument.replacedBy.instrumentId }}
        </div>
        <div class="cell medium-4">
          <div class="bold">Date this instrument was replaced:</div>
          {{ instrument.replacedBy.replacementApprovalDate | date }}
        </div>
      }
      <div class="cell medium-4">
        <div class="bold">Number:</div>
        {{ instrument.instrumentId }}
      </div>
      <div class="cell medium-4">
        <label class="bold">Amount:</label>
        {{ instrument.amount | currency }}
      </div>
      @if (instrument.typeCode.toUpperCase() == 'D') {
        <div class="cell medium-4">
          <label class="bold">Maturity Date:</label>
          {{ getExpirationDate() }}
        </div>
      }
      @if (instrument.typeCode.toUpperCase() == 'LC') {
        <div class="cell medium-4">
          <label class="bold">Expiration Date:</label>
          {{ getExpirationDate() }}
        </div>
      }
      @if (instrument.typeCode.toUpperCase() != 'LC' && instrument.typeCode.toUpperCase() != 'C') {
        <div class="cell medium-4">
          <label class="bold">Expiration Date:</label>
          {{ getExpirationDate() }}
        </div>
      }
      <div class="cell small-4">
        <label class="bold">Guarantor Name:</label>
        {{ instrument.guarantor?.name }}
      </div>
      <div class="cell small-4">
        <label class="bold">Guarantor Phone:</label>
        {{ phoneFormatter(instrument.guarantor?.phoneNumber) }}
      </div>
      <div class="cell small-4">
        <label class="bold">Guarantor Fax:</label>
        {{ phoneFormatter(instrument.guarantor?.faxNumber) }}
      </div>
      <div class="cell small-4">
        <label class="bold">Guarantor Email:</label>
        {{ instrument.guarantor?.email }}
      </div>
      <div class="cell small-8">
        <label class="bold">Guarantor Address:</label>
        {{ instrument.guarantor?.address?.street }} {{ instrument.guarantor?.address?.suite }}<br>
        @if (instrument.guarantor?.address?.poBox) {
          {{ instrument.guarantor?.address?.poBox }} <br>
        }
        {{ instrument.guarantor?.address?.city }}, {{ instrument.guarantor?.address?.stateCode }}
        {{ instrument.guarantor?.address?.zipCode }} <br>
      </div>
    </div>
  </div>
}

@if (!instrument) {
  <div class="margin-top margin-left">
    <h2>Could not load finacial instrument</h2>
  </div>
}